(function () {
  "use strict";

  const CONFIG = {
    MASTER_JSON_URL:
      "https://cdn.shopify.com/s/files/1/0768/5029/9147/files/exploded-view-table-data.json?v=1790014100",

    CONCURRENCY: 5,

    CACHE_TTL: 1000 * 60 * 60 * 24,

    CACHE_PREFIX: "exploded-view-product-",

    CONTAINER_ID: "exploded-view-app",

    MASTER_CACHE_KEY: "exploded-view-master-v2",

    DEBUG: true,

    /*
     * Originalaus Shopify produkto aprašymo slėpimas.
     */
    HIDE_ORIGINAL_DESCRIPTION: true
  };


  // =========================================================
  // VERTIMAI
  // =========================================================

  const TRANSLATIONS = {

    lt: {
      title: "Išklotinės brėžinys",
      loading: "Kraunamos detalės...",
      error:
        "Nepavyko užkrauti išklotinės duomenų. Bandykite vėliau.",
      noData: "Išklotinės detalių duomenų nėra.",

      position: "Poz.",
      sku: "Detalės kodas",
      description: "Pavadinimas",
      qty: "Kiekis",
      price: "Kaina",
      stock: "Sandėlis",
      buy: "Pirkti",

      notFound: "Nerasta parduotuvėje",
      addToCart: "Į krepšelį",
      adding: "Dedama...",
      added: "✓ Įdėta",
      errorAdd: "Klaida",

      inStock: "Sandėlyje",
      backorder: "Užsakoma prekė 1-4 savaitės",
      outOfStock: "Išparduota",
      unknown: "—"
    },

    en: {
      title: "Exploded View",
      loading: "Loading parts...",
      error:
        "Failed to load exploded view data. Please try again.",
      noData: "No exploded view data available.",

      position: "Pos.",
      sku: "Part No.",
      description: "Description",
      qty: "Qty",
      price: "Price",
      stock: "Stock",
      buy: "Buy",

      notFound: "Not found in store",
      addToCart: "Add to cart",
      adding: "Adding...",
      added: "✓ Added",
      errorAdd: "Error",

      inStock: "In stock",
      backorder: "Item on order 1-4 weeks",
      outOfStock: "Sold out",
      unknown: "—"
    },

    de: {
      title: "Explosionszeichnung",
      loading: "Teile werden geladen...",
      error:
        "Fehler beim Laden der Explosionszeichnung. Bitte versuchen Sie es erneut.",
      noData: "Keine Explosionszeichnungsdaten verfügbar.",

      position: "Pos.",
      sku: "Teilenr.",
      description: "Beschreibung",
      qty: "Menge",
      price: "Preis",
      stock: "Lager",
      buy: "Kaufen",

      notFound: "Im Shop nicht gefunden",
      addToCart: "In den Warenkorb",
      adding: "Wird hinzugefügt...",
      added: "✓ Hinzugefügt",
      errorAdd: "Fehler",

      inStock: "Auf Lager",
      backorder: "Artikel auf Bestellung 1-4 Wochen",
      outOfStock: "Ausverkauft",
      unknown: "—"
    }
  };


  // =========================================================
  // KALBA
  // =========================================================

  function getLocale() {

    const lang =
      document.documentElement.lang ||
      (window.Shopify && Shopify.locale) ||
      "lt";

    const normalized =
      String(lang).toLowerCase();

    if (normalized.startsWith("lt")) return "lt";
    if (normalized.startsWith("en")) return "en";
    if (normalized.startsWith("de")) return "de";

    return "lt";
  }


  function t(key) {

    const locale =
      getLocale();

    return (
      TRANSLATIONS[locale]?.[key] ||
      TRANSLATIONS.lt[key] ||
      key
    );
  }


  // =========================================================
  // LOGGING
  // =========================================================

  function log() {

    if (!CONFIG.DEBUG) return;

    console.log(
      "%c[Exploded View]",
      "font-weight:bold;color:#1976d2",
      ...arguments
    );
  }


  function warn() {

    console.warn(
      "%c[Exploded View]",
      "font-weight:bold;color:#f57c00",
      ...arguments
    );
  }


  function error() {

    console.error(
      "%c[Exploded View]",
      "font-weight:bold;color:#d32f2f",
      ...arguments
    );
  }


  // =========================================================
  // HELPERS
  // =========================================================

  function escapeHtml(value) {

    if (value == null) return "";

    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }


  function normalizeHandle(value) {

    if (!value) return "";

    return String(value)
      .trim()
      .toLowerCase()
      .replace(/^\/+/, "")
      .replace(/\/+$/, "")
      .split("?")[0]
      .split("#")[0];
  }


  function getModelKeyFromHandle(handle) {

    let h =
      normalizeHandle(handle);

    if (h.startsWith("exploded-")) {
      h =
        h.substring("exploded-".length);
    }

    return h;
  }


  function formatMoney(cents, currency) {

    if (
      cents == null ||
      isNaN(Number(cents))
    ) {
      return "—";
    }

    const amount =
      Number(cents) / 100;

    try {

      return new Intl.NumberFormat(
        getLocale() === "lt"
          ? "lt-LT"
          : "en-US",
        {
          style: "currency",
          currency: currency || "EUR"
        }
      ).format(amount);

    } catch (e) {

      return (
        amount.toFixed(2) +
        " " +
        (currency || "EUR")
      );
    }
  }


  function getShopifyRoot() {

    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return "/";
  }


  function getProductHandleFromUrl() {

    const match =
      window.location.pathname.match(
        /\/products\/([^\/?#]+)/i
      );

    return match
      ? normalizeHandle(match[1])
      : "";
  }


  function isProductPage() {

    return (
      /^\/[^\/]+\/products\/[^\/?#]+/.test(
        window.location.pathname
      ) ||
      /^\/products\/[^\/?#]+/.test(
        window.location.pathname
      )
    );
  }


  // =========================================================
  // ORIGINALAUS APRAŠYMO BLOKO SLĖPIMAS
  // =========================================================

  function hideOriginalDescription() {

    if (!CONFIG.HIDE_ORIGINAL_DESCRIPTION) {
      return;
    }

    /*
     * Tavo temoje originalus aprašymas yra:
     *
     * .product-block-list__item.product-block-list__item--description
     *
     * Todėl slepiame VISĄ bloką.
     */

    const selectors = [

      ".product-block-list__item.product-block-list__item--description",

      ".product-block-list__item--description"

    ];


    let hiddenCount = 0;


    selectors.forEach(selector => {

      const elements =
        document.querySelectorAll(selector);


      elements.forEach(element => {

        /*
         * Neslepiame mūsų pačių Exploded View konteinerio,
         * jei tema netyčia įdėtų jį į panašią struktūrą.
         */

        if (
          element.id === CONFIG.CONTAINER_ID ||
          element.contains(
            document.getElementById(
              CONFIG.CONTAINER_ID
            )
          )
        ) {
          return;
        }


        element.style.setProperty(
          "display",
          "none",
          "important"
        );


        element.setAttribute(
          "data-exploded-view-hidden",
          "true"
        );


        hiddenCount++;
      });
    });


    if (hiddenCount > 0) {

      log(
        "Original description hidden:",
        hiddenCount
      );

      return true;
    }


    return false;
  }


  /*
   * Kai kurios Shopify temos turinį įkelia šiek tiek vėliau.
   *
   * Todėl dar kartą patikriname po DOM pakeitimų.
   */

  function watchOriginalDescription() {

    if (!CONFIG.HIDE_ORIGINAL_DESCRIPTION) {
      return;
    }


    hideOriginalDescription();


    const observer =
      new MutationObserver(() => {

        hideOriginalDescription();

      });


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );


    /*
     * Po kurio laiko stebėjimą galima išjungti,
     * kad nereikėtų be reikalo stebėti viso DOM.
     */

    setTimeout(() => {

      observer.disconnect();

      log(
        "Original description observer stopped."
      );

    }, 10000);
  }


  // =========================================================
  // CACHE
  // =========================================================

  function cacheGet(key) {

    try {

      const raw =
        localStorage.getItem(key);

      if (!raw) return null;

      const data =
        JSON.parse(raw);

      if (
        !data ||
        !data.timestamp
      ) {
        return null;
      }

      if (
        Date.now() - data.timestamp >
        CONFIG.CACHE_TTL
      ) {

        localStorage.removeItem(key);

        return null;
      }

      return data.value;

    } catch (e) {

      return null;
    }
  }


  function cacheSet(key, value) {

    try {

      localStorage.setItem(
        key,
        JSON.stringify({
          timestamp: Date.now(),
          value: value
        })
      );

    } catch (e) {

      // ignore
    }
  }


  // =========================================================
  // FETCH JSON
  // =========================================================

  async function fetchJson(url) {

    log(
      "Fetching:",
      url
    );

    const response =
      await fetch(url, {
        credentials: "same-origin",
        cache: "no-cache"
      });


    if (!response.ok) {

      throw new Error(
        "HTTP " +
        response.status +
        " - " +
        url
      );
    }


    return await response.json();
  }


  // =========================================================
  // MASTER JSON
  // =========================================================

  async function loadMaster() {

    const cached =
      cacheGet(
        CONFIG.MASTER_CACHE_KEY
      );


    if (cached) {

      log(
        "Master JSON from cache"
      );

      return cached;
    }


    log(
      "Loading master JSON..."
    );


    const data =
      await fetchJson(
        CONFIG.MASTER_JSON_URL
      );


    if (
      !data ||
      typeof data !== "object" ||
      Array.isArray(data)
    ) {

      throw new Error(
        "Master JSON is not an object."
      );
    }


    cacheSet(
      CONFIG.MASTER_CACHE_KEY,
      data
    );


    log(
      "Master loaded. Models:",
      Object.keys(data).length
    );


    return data;
  }


  function findModel(
    master,
    modelKey
  ) {

    const key =
      normalizeHandle(modelKey);


    log(
      "Looking for model key:",
      key
    );


    if (
      !master ||
      typeof master !== "object"
    ) {
      return null;
    }


    for (
      const k of Object.keys(master)
    ) {

      if (
        k.toLowerCase() === key
      ) {

        return {
          key: k,
          data: master[k]
        };
      }
    }


    return null;
  }


  // =========================================================
  // CONTAINER
  // =========================================================

  function createContainer() {

    const existing =
      document.getElementById(
        CONFIG.CONTAINER_ID
      );


    if (existing) {
      return existing;
    }


    const targetSelectors = [

      ".product-single__description",

      ".product__description",

      ".product-description",

      ".rte",

      ".product__info-container .rte",

      "#shopify-section-product-template .rte",

      "main .rte"

    ];


    let target = null;


    for (
      const sel of targetSelectors
    ) {

      const el =
        document.querySelector(sel);


      if (el) {

        target = el;

        break;
      }
    }


    if (!target) {

      const fallback =
        document.querySelector(
          ".product-form, .product__buy-buttons, [data-product-form]"
        );


      if (fallback) {
        target = fallback;
      }
    }


    if (!target) {

      warn(
        "Could not find placement for Exploded View."
      );

      return null;
    }


    const container =
      document.createElement("div");


    container.id =
      CONFIG.CONTAINER_ID;


    container.className =
      "exploded-view-container";


    target.parentNode.insertBefore(
      container,
      target.nextSibling
    );


    return container;
  }


  // =========================================================
  // STYLES
  // =========================================================

  function injectStyles() {

    if (
      document.getElementById(
        "exploded-view-styles"
      )
    ) {
      return;
    }


    const style =
      document.createElement("style");


    style.id =
      "exploded-view-styles";


    style.textContent = `

      #${CONFIG.CONTAINER_ID} {
        width: 100%;
        margin: 35px 0;
        clear: both;
        overflow: hidden;
      }

      #${CONFIG.CONTAINER_ID} .ev-title {
        font-size: 24px;
        line-height: 1.3;
        font-weight: 600;
        margin: 0 0 18px;
      }

      #${CONFIG.CONTAINER_ID} .ev-subtitle {
        margin: 0 0 20px;
        color: #666;
        font-size: 14px;
      }

      #${CONFIG.CONTAINER_ID} .ev-table-wrapper {
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        margin: 0 -1px;
      }

      #${CONFIG.CONTAINER_ID} table.ev-table {
        width: 100%;
        min-width: 700px;
        border-collapse: collapse;
        font-size: 14px;
      }

      #${CONFIG.CONTAINER_ID} .ev-table th {
        text-align: left;
        padding: 12px 10px;
        border-bottom: 2px solid #ddd;
        font-weight: 600;
        white-space: nowrap;
      }

      #${CONFIG.CONTAINER_ID} .ev-table td {
        padding: 11px 10px;
        border-bottom: 1px solid #e5e5e5;
        vertical-align: middle;
      }

      #${CONFIG.CONTAINER_ID} .ev-item {
        width: 60px;
        font-weight: 600;
        white-space: nowrap;
        text-align: center;
      }

      #${CONFIG.CONTAINER_ID} .ev-sku {
        white-space: nowrap;
        font-family: monospace;
        font-size: 13px;
      }

      #${CONFIG.CONTAINER_ID} .ev-description {
        min-width: 160px;
      }

      #${CONFIG.CONTAINER_ID} .ev-qty {
        text-align: center;
        white-space: nowrap;
      }

      #${CONFIG.CONTAINER_ID} .ev-price {
        white-space: nowrap;
        font-weight: 600;
      }

      #${CONFIG.CONTAINER_ID} .ev-status {
        white-space: nowrap;
      }

      #${CONFIG.CONTAINER_ID} .ev-status-in {
        color: #16803c;
        font-weight: 600;
      }

      #${CONFIG.CONTAINER_ID} .ev-status-backorder {
        color: #b26a00;
        font-weight: 600;
      }

      #${CONFIG.CONTAINER_ID} .ev-status-out {
        color: #b42318;
        font-weight: 600;
      }

      #${CONFIG.CONTAINER_ID} .ev-status-unknown {
        color: #777;
      }

      #${CONFIG.CONTAINER_ID} .ev-product-link {
        color: inherit;
        text-decoration: none;
      }

      #${CONFIG.CONTAINER_ID} .ev-product-link:hover {
        text-decoration: underline;
      }

      #${CONFIG.CONTAINER_ID} .ev-add-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 100px;
        min-height: 36px;
        padding: 5px 12px;
        border: 0;
        border-radius: 4px;
        cursor: pointer;
        font-size: 13px;
        font-weight: 600;
        background: #111;
        color: #fff;
        white-space: nowrap;
      }

      #${CONFIG.CONTAINER_ID} .ev-add-button:hover {
        opacity: .85;
      }

      #${CONFIG.CONTAINER_ID} .ev-add-button:disabled {
        cursor: not-allowed;
        opacity: .45;
      }

      #${CONFIG.CONTAINER_ID} .ev-add-button.is-added {
        background: #198754;
      }

      #${CONFIG.CONTAINER_ID} .ev-error {
        padding: 15px;
        border: 1px solid #ddd;
        background: #fafafa;
        color: #666;
      }

      #${CONFIG.CONTAINER_ID} .ev-loading {
        padding: 15px 0;
        color: #666;
      }

      #${CONFIG.CONTAINER_ID} .ev-missing {
        color: #999;
        font-style: italic;
      }

      #${CONFIG.CONTAINER_ID} .ev-table tbody tr.ev-marker-active {
        background: rgba(25, 118, 210, .10);
        outline: 2px solid rgba(25, 118, 210, .35);
        outline-offset: -2px;
      }

      #${CONFIG.CONTAINER_ID} .ev-table tbody tr[data-ev-has-marker="1"] {
        cursor: pointer;
      }

      .ev-marker-layer {
        position: absolute;
        z-index: 99999;
        pointer-events: none;
        overflow: visible;
      }

      .ev-marker {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: absolute;
        transform: translate(-50%, -50%);
        min-width: 28px;
        height: 28px;
        padding: 0 6px;
        border: 2px solid #fff;
        border-radius: 999px;
        background: #d32f2f;
        color: #fff;
        font: 700 11px/24px Arial, sans-serif;
        text-align: center;
        box-sizing: border-box;
        box-shadow: 0 1px 5px rgba(0, 0, 0, .45);
        cursor: pointer;
        pointer-events: auto;
        user-select: none;
        white-space: nowrap;
      }

      .ev-marker:hover,
      .ev-marker:focus-visible,
      .ev-marker.ev-marker-active {
        background: #1976d2;
        transform: translate(-50%, -50%) scale(1.14);
        z-index: 100000;
        outline: none;
      }

      @media (max-width: 768px) {

        #${CONFIG.CONTAINER_ID} .ev-table {
          min-width: 600px;
        }

        #${CONFIG.CONTAINER_ID} .ev-add-button {
          min-width: 80px;
          font-size: 12px;
          padding: 4px 8px;
        }
      }

      @media (max-width: 480px) {

        #${CONFIG.CONTAINER_ID} .ev-table {
          min-width: 520px;
          font-size: 12px;
        }

        #${CONFIG.CONTAINER_ID} .ev-table th,
        #${CONFIG.CONTAINER_ID} .ev-table td {
          padding: 8px 6px;
        }

        #${CONFIG.CONTAINER_ID} .ev-add-button {
          min-width: 60px;
          font-size: 11px;
          padding: 3px 6px;
          min-height: 30px;
        }

        #${CONFIG.CONTAINER_ID} .ev-item {
          width: 40px;
        }

        #${CONFIG.CONTAINER_ID} .ev-sku {
          font-size: 11px;
        }
      }
    `;


    document.head.appendChild(style);
  }



  // =========================================================
  // EXPLODED VIEW MARKERS
  // =========================================================

  function normalizeMarkerLabel(value) {
    const raw = String(value == null ? "" : value);
    const cleaned = raw.replace(/^0+(?=\d)/, "");
    return cleaned || raw || "";
  }


  function getImageSearchText(img) {
    if (!img) return "";

    const values = [
      img.currentSrc,
      img.src,
      img.getAttribute("src"),
      img.getAttribute("data-src"),
      img.getAttribute("data-zoom"),
      img.getAttribute("data-zoom-src"),
      img.getAttribute("alt"),
      img.getAttribute("title"),
      img.getAttribute("srcset")
    ];

    return values
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
  }


  function findExplodedImage(filename, modelKey) {
    const images =
      Array.from(
        document.querySelectorAll("img")
      );

    const wanted =
      String(filename || "")
        .trim()
        .toLowerCase();

    const wantedNoExt =
      wanted.replace(/\.[a-z0-9]+$/i, "");

    const model =
      String(modelKey || "")
        .trim()
        .toLowerCase();

    const candidates = [];

    images.forEach(img => {
      if (
        img.closest(
          "#" + CONFIG.CONTAINER_ID
        )
      ) {
        return;
      }

      const text =
        getImageSearchText(img);

      const filenameMatch =
        (
          wanted &&
          text.includes(wanted)
        ) ||
        (
          wantedNoExt &&
          text.includes(wantedNoExt)
        );

      const modelMatch =
        model &&
        text.includes(model);

      if (
        !filenameMatch &&
        !modelMatch
      ) {
        return;
      }

      const rect =
        img.getBoundingClientRect();

      const style =
        window.getComputedStyle(img);

      const visible =
        rect.width > 0 &&
        rect.height > 0 &&
        style.display !== "none" &&
        style.visibility !== "hidden" &&
        Number(style.opacity || 1) > 0;

      if (!visible) {
        return;
      }

      const area =
        rect.width *
        rect.height;

      candidates.push({
        img,
        rect,
        area,
        filenameMatch,
        modelMatch
      });
    });


    if (!candidates.length) {
      warn(
        "No visible exploded image found:",
        filename,
        modelKey
      );

      return null;
    }


    const exact =
      candidates.filter(
        item =>
          item.filenameMatch
      );


    const pool =
      exact.length
        ? exact
        : candidates;


    pool.sort(
      (a, b) =>
        b.area - a.area
    );


    const selected =
      pool[0];


    log(
      "Selected exploded image:",
      filename,
      Math.round(selected.rect.width) +
        "x" +
        Math.round(selected.rect.height),
      selected.img.currentSrc ||
        selected.img.src
    );


    return selected.img;
  }


  function clearExplodedMarkers() {
    const old =
      window.__explodedViewMarkerState;

    if (!old) {
      return;
    }

    if (old.rafId) {
      cancelAnimationFrame(
        old.rafId
      );
    }

    if (old.resizeObserver) {
      old.resizeObserver.disconnect();
    }

    if (old.mutationObserver) {
      old.mutationObserver.disconnect();
    }

    if (old.onWindowChange) {
      window.removeEventListener(
        "resize",
        old.onWindowChange
      );

      window.removeEventListener(
        "scroll",
        old.onWindowChange,
        true
      );
    }

    (old.layers || [])
      .forEach(layer => {
        layer.remove();
      });

    window.__explodedViewMarkerState =
      null;
  }


  function activateMarker(
    container,
    partIndex,
    scrollToRow
  ) {
    if (!container) {
      return;
    }

    const rows =
      container.querySelectorAll(
        "tbody tr[data-ev-row]"
      );

    rows.forEach(row => {
      row.classList.remove(
        "ev-marker-active"
      );
    });

    document
      .querySelectorAll(
        ".ev-marker.ev-marker-active"
      )
      .forEach(marker => {
        marker.classList.remove(
          "ev-marker-active"
        );
      });

    const row =
      container.querySelector(
        `tbody tr[data-ev-row="${partIndex}"]`
      );

    if (row) {
      row.classList.add(
        "ev-marker-active"
      );

      if (scrollToRow) {
        row.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
      }
    }

    document
      .querySelectorAll(
        `.ev-marker[data-ev-part-index="${partIndex}"]`
      )
      .forEach(marker => {
        marker.classList.add(
          "ev-marker-active"
        );
      });
  }


  function setupExplodedMarkers(
    container,
    modelData,
    modelKey
  ) {
    clearExplodedMarkers();

    if (!container) {
      return;
    }

    const parts =
      Array.isArray(modelData.p)
        ? modelData.p
        : [];

    const imageFiles =
      Array.isArray(modelData.i)
        ? modelData.i
        : [];

    const markedParts =
      parts
        .map((part, index) => ({
          part,
          index
        }))
        .filter(entry => {
          const part =
            entry.part;

          return (
            Number.isFinite(
              Number(part.x)
            ) &&
            Number.isFinite(
              Number(part.y)
            )
          );
        });

    if (!markedParts.length) {
      log(
        "No marker coordinates for model:",
        modelKey
      );
      return;
    }


    markedParts.forEach(entry => {
      const row =
        container.querySelector(
          `tbody tr[data-ev-row="${entry.index}"]`
        );

      if (!row) {
        return;
      }

      row.dataset.evHasMarker =
        "1";

      row.addEventListener(
        "click",
        function () {
          activateMarker(
            container,
            entry.index,
            false
          );
        }
      );
    });


    const groups =
      new Map();


    markedParts.forEach(entry => {
      const rawGroup =
        entry.part.g;

      const imageIndex =
        Number.isFinite(
          Number(rawGroup)
        )
          ? Number(rawGroup)
          : 0;

      if (!groups.has(imageIndex)) {
        groups.set(
          imageIndex,
          []
        );
      }

      groups
        .get(imageIndex)
        .push(entry);
    });


    const state = {
      layers: [],
      bindings: [],
      rafId: null,
      resizeObserver: null,
      mutationObserver: null,
      onWindowChange: null
    };


    groups.forEach(
      (entries, imageIndex) => {
        const filename =
          imageFiles[imageIndex] ||
          imageFiles[0] ||
          "";

        const image =
          findExplodedImage(
            filename,
            modelKey
          );

        if (!image) {
          warn(
            "Could not find exploded image for markers:",
            filename || modelKey,
            "image index:",
            imageIndex
          );
          return;
        }

        const layer =
          document.createElement(
            "div"
          );

        layer.className =
          "ev-marker-layer";

        layer.dataset.evImageIndex =
          String(imageIndex);

        document.body.appendChild(
          layer
        );


        entries.forEach(entry => {
          const part =
            entry.part;

          const marker =
            document.createElement(
              "button"
            );

          marker.type =
            "button";

          marker.className =
            "ev-marker";

          marker.dataset.evPartIndex =
            String(entry.index);

          marker.style.left =
            Number(part.x) + "%";

          marker.style.top =
            Number(part.y) + "%";

          marker.textContent =
            normalizeMarkerLabel(
              part.i
            );

          marker.title =
            [
              part.i
                ? "Poz. " + part.i
                : "",
              part.s || "",
              part.d || ""
            ]
              .filter(Boolean)
              .join(" – ");

          marker.setAttribute(
            "aria-label",
            marker.title ||
              ("Poz. " + part.i)
          );

          marker.addEventListener(
            "click",
            function (event) {
              event.preventDefault();
              event.stopPropagation();

              activateMarker(
                container,
                entry.index,
                true
              );
            }
          );

          layer.appendChild(
            marker
          );
        });


        state.layers.push(
          layer
        );

        state.bindings.push({
          image,
          layer
        });
      }
    );


    if (!state.bindings.length) {
      return;
    }


    function updateMarkerLayers() {
      state.rafId =
        null;

      state.bindings.forEach(binding => {
        const rect =
          binding.image
            .getBoundingClientRect();

        log(
          "Marker image rect:",
          Math.round(rect.left),
          Math.round(rect.top),
          Math.round(rect.width),
          Math.round(rect.height)
        );

        const style =
          window.getComputedStyle(
            binding.image
          );

        const visible =
          rect.width > 1 &&
          rect.height > 1 &&
          style.display !== "none" &&
          style.visibility !== "hidden" &&
          Number(style.opacity || 1) !== 0;

        if (!visible) {
          binding.layer.style.display =
            "none";
          return;
        }

        binding.layer.style.display =
          "block";

        binding.layer.style.left =
          (
            rect.left +
            window.scrollX
          ) + "px";

        binding.layer.style.top =
          (
            rect.top +
            window.scrollY
          ) + "px";

        binding.layer.style.width =
          rect.width + "px";

        binding.layer.style.height =
          rect.height + "px";
      });
    }


    function scheduleMarkerUpdate() {
      if (state.rafId) {
        return;
      }

      state.rafId =
        requestAnimationFrame(
          updateMarkerLayers
        );
    }


    state.onWindowChange =
      scheduleMarkerUpdate;


    window.addEventListener(
      "resize",
      state.onWindowChange,
      {
        passive: true
      }
    );

    window.addEventListener(
      "scroll",
      state.onWindowChange,
      true
    );


    if (
      "ResizeObserver" in window
    ) {
      state.resizeObserver =
        new ResizeObserver(
          scheduleMarkerUpdate
        );

      state.bindings.forEach(
        binding => {
          state.resizeObserver.observe(
            binding.image
          );
        }
      );
    }


    state.mutationObserver =
      new MutationObserver(
        scheduleMarkerUpdate
      );

    state.mutationObserver.observe(
      document.body,
      {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: [
          "class",
          "style",
          "src",
          "srcset"
        ]
      }
    );


    window.__explodedViewMarkerState =
      state;


    updateMarkerLayers();


    log(
      "Markers ready:",
      markedParts.length,
      "images:",
      state.bindings.length
    );
  }


  function setupExplodedMarkersWithRetry(
    container,
    modelData,
    modelKey
  ) {
    const delays = [
      0,
      500,
      1500,
      3000
    ];

    delays.forEach(delay => {
      setTimeout(
        function () {
          const state =
            window.__explodedViewMarkerState;

          if (
            state &&
            state.bindings &&
            state.bindings.length
          ) {
            return;
          }

          setupExplodedMarkers(
            container,
            modelData,
            modelKey
          );
        },
        delay
      );
    });
  }


  // =========================================================
  // RENDER TABLE
  // =========================================================

  function renderInitialTable(
    container,
    modelData,
    modelKey
  ) {

    const parts =
      Array.isArray(modelData.p)
        ? modelData.p
        : [];


    if (!parts.length) {

      container.innerHTML = `
        <div class="ev-title">
          ${t("title")}
        </div>

        <div class="ev-error">
          ${t("noData")}
        </div>
      `;

      return;
    }


    const rows =
      parts
        .map((part, index) => {

          const item =
            part.i || "";

          const sku =
            part.s || "";

          const qty =
            part.q || 1;

          const found =
            part.f === 1;

          const handleFromPart =
            part.h || "";


          return `

            <tr
              data-ev-row="${index}"
              data-part-no="${escapeHtml(sku)}"
              data-handle="${escapeHtml(handleFromPart)}"
            >

              <td class="ev-item">
                ${escapeHtml(
                  String(item)
                    .replace(/^0+/, "") ||
                  "0"
                )}
              </td>

              <td class="ev-sku">
                ${escapeHtml(
                  sku || "—"
                )}
              </td>

              <td class="ev-description">
                ${escapeHtml(
                  sku || "—"
                )}
              </td>

              <td class="ev-qty">
                ${escapeHtml(qty)}
              </td>

              <td
                class="ev-price"
                data-ev-price
              >
                —
              </td>

              <td
                class="ev-status"
                data-ev-status
              >

                ${
                  found
                    ? t("loading")
                    : `
                      <span class="ev-missing">
                        ${t("notFound")}
                      </span>
                    `
                }

              </td>

              <td>

                <button
                  type="button"
                  class="ev-add-button"
                  data-ev-add
                  ${found ? "" : "disabled"}
                >

                  ${
                    found
                      ? t("addToCart")
                      : t("notFound")
                  }

                </button>

              </td>

            </tr>
          `;
        })
        .join("");


    container.innerHTML = `

      <div class="ev-title">
        ${t("title")}
      </div>

      <div class="ev-subtitle">
        ${escapeHtml(modelKey)}
      </div>

      <div class="ev-table-wrapper">

        <table class="ev-table">

          <thead>

            <tr>

              <th>
                ${t("position")}
              </th>

              <th>
                ${t("sku")}
              </th>

              <th>
                ${t("description")}
              </th>

              <th>
                ${t("qty")}
              </th>

              <th>
                ${t("price")}
              </th>

              <th>
                ${t("stock")}
              </th>

              <th>
                ${t("buy")}
              </th>

            </tr>

          </thead>

          <tbody>
            ${rows}
          </tbody>

        </table>

      </div>
    `;
  }


  // =========================================================
  // SHOPIFY PRODUCT
  // =========================================================

  async function fetchShopifyProduct(handle) {

    const normalized =
      normalizeHandle(handle);


    if (!normalized) {
      return null;
    }


    const cacheKey =
      CONFIG.CACHE_PREFIX +
      normalized;


    const cached =
      cacheGet(cacheKey);


    if (cached) {
      return cached;
    }


    const root =
      getShopifyRoot();


    const url =
      root +
      "products/" +
      encodeURIComponent(normalized) +
      ".js";


    try {

      const response =
        await fetch(
          url,
          {
            credentials:
              "same-origin",

            cache:
              "no-cache"
          }
        );


      if (!response.ok) {

        if (
          response.status === 404
        ) {

          warn(
            "Shopify product not found:",
            normalized
          );

          return null;
        }


        throw new Error(
          "HTTP " +
          response.status
        );
      }


      const product =
        await response.json();


      cacheSet(
        cacheKey,
        product
      );


      return product;

    } catch (err) {

      warn(
        "Shopify product error:",
        normalized,
        err
      );

      return null;
    }
  }


  // =========================================================
  // QUEUE
  // =========================================================

  async function runQueue(
    items,
    worker,
    concurrency
  ) {

    const results =
      new Array(
        items.length
      );


    let nextIndex = 0;


    async function runner() {

      while (true) {

        const index =
          nextIndex++;


        if (
          index >= items.length
        ) {
          return;
        }


        try {

          results[index] =
            await worker(
              items[index],
              index
            );

        } catch (err) {

          results[index] =
            null;


          warn(
            "Queue worker error:",
            err
          );
        }
      }
    }


    const workers =
      Math.min(
        concurrency,
        items.length
      );


    await Promise.all(
      Array.from(
        {
          length: workers
        },
        () => runner()
      )
    );


    return results;
  }


  // =========================================================
  // PRODUCT DATA
  // =========================================================

  function getFirstAvailableVariant(
    product
  ) {

    if (
      !product ||
      !Array.isArray(
        product.variants
      )
    ) {

      return null;
    }


    const variant =
      product.variants.find(
        v =>
          v.available === true
      );


    return (
      variant ||
      product.variants[0] ||
      null
    );
  }


  // =========================================================
  // STATUS NORMALIZAVIMAS
  // =========================================================

  function normalizeStatusText(
    text
  ) {

    if (!text) {
      return null;
    }


    const value =
      String(text)
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();


    if (!value) {
      return null;
    }


    const outPatterns = [

      "išparduota",
      "išparduotas",
      "išparduoti",
      "nėra sandėlyje",

      "sold out",
      "out of stock",
      "currently unavailable",
      "unavailable",

      "ausverkauft",
      "nicht auf lager",
      "nicht lagernd"
    ];


    if (
      outPatterns.some(
        pattern =>
          value.includes(pattern)
      )
    ) {

      return {
        type: "out",
        text: t("outOfStock")
      };
    }


    const backorderPatterns = [

      "užsakoma prekė",
      "užsakoma",
      "pagal užsakymą",
      "užsakymu",

      "item on order",
      "on order",
      "backorder",
      "back order",
      "available on order",
      "special order",

      "artikel auf bestellung",
      "auf bestellung",
      "vorbestellung",
      "bestellware",
      "nachbestellung",

      "1-4"
    ];


    const hasBackorderWord =
      backorderPatterns.some(
        pattern =>
          value.includes(pattern)
      );


    const hasWeeks =
      /1\s*[-–]\s*4\s*(savait|week|wochen)/i.test(
        value
      );


    if (
      hasBackorderWord ||
      hasWeeks
    ) {

      return {
        type: "backorder",
        text: t("backorder")
      };
    }


    const inStockPatterns = [

      "sandėlyje",
      "yra sandėlyje",
      "turime sandėlyje",

      "in stock",
      "available",
      "available now",

      "auf lager",
      "lagernd",
      "sofort verfügbar",
      "verfügbar"
    ];


    if (
      inStockPatterns.some(
        pattern =>
          value.includes(pattern)
      )
    ) {

      return {
        type: "in",
        text: t("inStock")
      };
    }


    warn(
      "Unknown Shopify stock status:",
      text
    );


    return null;
  }


  // =========================================================
  // HTML STOCK STATUS
  // =========================================================

  async function fetchStockStatusFromHtml(
    handle
  ) {

    const normalized =
      normalizeHandle(handle);


    if (!normalized) {
      return null;
    }


    const root =
      getShopifyRoot();


    const url =
      root +
      "products/" +
      encodeURIComponent(
        normalized
      );


    try {

      const response =
        await fetch(
          url,
          {
            credentials:
              "same-origin",

            cache:
              "no-store"
          }
        );


      if (!response.ok) {
        return null;
      }


      const html =
        await response.text();


      const doc =
        new DOMParser()
          .parseFromString(
            html,
            "text/html"
          );


      const stockEl =
        doc.querySelector(
          "#product-stock-status"
        );


      if (stockEl) {

        const text =
          stockEl.textContent
            .replace(/\s+/g, " ")
            .trim();


        if (text) {

          const normalizedStatus =
            normalizeStatusText(
              text
            );


          if (normalizedStatus) {
            return normalizedStatus;
          }
        }
      }


      const fallbackEl =
        doc.querySelector(
          ".product-stock, .product__stock, .product-single__stock, .stock-status, [data-product-stock]"
        );


      if (fallbackEl) {

        const text =
          fallbackEl.textContent
            .replace(/\s+/g, " ")
            .trim();


        if (text) {

          const normalizedStatus =
            normalizeStatusText(
              text
            );


          if (normalizedStatus) {
            return normalizedStatus;
          }
        }
      }


      return null;

    } catch (err) {

      warn(
        "Stock status HTML fetch error:",
        normalized,
        err
      );

      return null;
    }
  }


  // =========================================================
  // UPDATE ROW
  // =========================================================

  async function updateRow(
    row,
    part
  ) {

    const handle =
      row.dataset.handle ||
      "";


    const priceCell =
      row.querySelector(
        "[data-ev-price]"
      );


    const statusCell =
      row.querySelector(
        "[data-ev-status]"
      );


    const button =
      row.querySelector(
        "[data-ev-add]"
      );


    if (!handle) {

      if (priceCell) {
        priceCell.textContent =
          "—";
      }


      if (statusCell) {

        statusCell.innerHTML =
          `<span class="ev-missing">${t("notFound")}</span>`;


        statusCell.className =
          "ev-status ev-status-unknown";
      }


      if (button) {

        button.disabled =
          true;

        button.textContent =
          t("notFound");
      }


      return;
    }


    const product =
      await fetchShopifyProduct(
        handle
      );


    if (!product) {

      if (priceCell) {
        priceCell.textContent =
          "—";
      }


      if (statusCell) {

        statusCell.innerHTML =
          `<span class="ev-missing">${t("notFound")}</span>`;


        statusCell.className =
          "ev-status ev-status-unknown";
      }


      if (button) {

        button.disabled =
          true;

        button.textContent =
          t("notFound");
      }


      return;
    }


    const variant =
      getFirstAvailableVariant(
        product
      );


    row.dataset.variantId =
      variant &&
      variant.id
        ? String(
            variant.id
          )
        : "";


    // =====================================================
    // KAINA
    // =====================================================

    if (
      priceCell &&
      variant
    ) {

      priceCell.textContent =
        formatMoney(
          variant.price,
          product.currency ||
            "EUR"
        );
    }


    // =====================================================
    // PAVADINIMAS
    // =====================================================

    const descCell =
      row.querySelector(
        ".ev-description"
      );


    if (
      descCell &&
      product.title
    ) {

      descCell.innerHTML = `

        <a
          class="ev-product-link"
          href="/products/${encodeURIComponent(
            product.handle
          )}"
        >
          ${escapeHtml(
            product.title
          )}
        </a>

      `;
    }


    // =====================================================
    // SANDĖLIO STATUSAS
    // =====================================================

    const stock =
      await getStockStatus(
        handle,
        product,
        variant
      );


    if (statusCell) {

      if (stock) {

        statusCell.textContent =
          stock.text;


        statusCell.className =
          "ev-status";


        if (
          stock.type === "in"
        ) {

          statusCell.classList.add(
            "ev-status-in"
          );

        } else if (
          stock.type ===
          "backorder"
        ) {

          statusCell.classList.add(
            "ev-status-backorder"
          );

        } else if (
          stock.type === "out"
        ) {

          statusCell.classList.add(
            "ev-status-out"
          );

        } else {

          statusCell.classList.add(
            "ev-status-unknown"
          );
        }

      } else {

        if (
          variant &&
          variant.available === true
        ) {

          statusCell.textContent =
            t("inStock");


          statusCell.className =
            "ev-status ev-status-in";

        } else {

          statusCell.textContent =
            t("unknown");


          statusCell.className =
            "ev-status ev-status-unknown";
        }
      }
    }


    // =====================================================
    // MYGTUKAS
    // =====================================================

    if (
      button &&
      variant &&
      variant.id
    ) {

      button.disabled =
        false;


      button.textContent =
        t("addToCart");


      const newButton =
        button.cloneNode(true);


      button.parentNode.replaceChild(
        newButton,
        button
      );


      newButton.addEventListener(
        "click",
        function () {

          addToCart(
            variant.id,
            1,
            newButton
          );

        }
      );

    } else if (button) {

      button.disabled =
        true;

      button.textContent =
        t("notFound");
    }
  }


  // =========================================================
  // GET STOCK STATUS
  // =========================================================

  async function getStockStatus(
    handle,
    product,
    variant
  ) {

    const htmlStatus =
      await fetchStockStatusFromHtml(
        handle
      );


    if (htmlStatus) {

      return htmlStatus;
    }


    if (
      variant &&
      variant.available === true
    ) {

      return {
        type: "in",
        text: t("inStock")
      };
    }


    return {
      type: "unknown",
      text: t("unknown")
    };
  }


  // =========================================================
  // ADD TO CART
  // =========================================================

  async function addToCart(
    variantId,
    quantity,
    button
  ) {

    if (!variantId) {
      return;
    }


    const originalText =
      button.textContent;


    button.disabled =
      true;


    button.textContent =
      t("adding");


    try {

      const root =
        getShopifyRoot();


      const response =
        await fetch(
          root +
          "cart/add.js",
          {
            method: "POST",

            headers: {
              "Content-Type":
                "application/json",

              "Accept":
                "application/json"
            },

            body:
              JSON.stringify({
                items: [
                  {
                    id:
                      Number(
                        variantId
                      ),

                    quantity:
                      Number(
                        quantity
                      ) || 1
                  }
                ]
              })
          }
        );


      const data =
        await response.json();


      if (!response.ok) {

        throw new Error(
          data.description ||
          data.message ||
          "Nepavyko įdėti prekės į krepšelį."
        );
      }


      button.textContent =
        t("added");


      button.classList.add(
        "is-added"
      );


      document.dispatchEvent(
        new CustomEvent(
          "exploded-view:cart-added",
          {
            detail: data
          }
        )
      );


      if (
        window.dispatchEvent
      ) {

        window.dispatchEvent(
          new CustomEvent(
            "cart:updated"
          )
        );
      }


      setTimeout(
        () => {

          button.disabled =
            false;

          button.textContent =
            originalText;

          button.classList.remove(
            "is-added"
          );

        },
        1500
      );


    } catch (err) {

      error(
        "Add to cart error:",
        err
      );


      button.disabled =
        false;


      button.textContent =
        t("errorAdd");


      setTimeout(
        () => {

          button.textContent =
            originalText;

        },
        2000
      );
    }
  }


  // =========================================================
  // LOAD SHOPIFY DATA
  // =========================================================

  async function loadShopifyData(
    container,
    modelData
  ) {

    const parts =
      Array.isArray(modelData.p)
        ? modelData.p
        : [];


    const rows =
      Array.from(
        container.querySelectorAll(
          "tbody tr"
        )
      );


    const handles =
      new Set();


    parts.forEach(
      part => {

        if (part.h) {

          handles.add(
            normalizeHandle(
              part.h
            )
          );
        }
      }
    );


    log(
      "Shopify products to load:",
      handles.size
    );


    await runQueue(
      Array.from(handles),

      async handle => {

        await fetchShopifyProduct(
          handle
        );

      },

      CONFIG.CONCURRENCY
    );


    await runQueue(
      parts,

      async (
        part,
        index
      ) => {

        const row =
          rows[index];


        if (row) {

          await updateRow(
            row,
            part
          );
        }

      },

      CONFIG.CONCURRENCY
    );
  }


  // =========================================================
  // KALBOS PAKEITIMO STEBĖJIMAS
  // =========================================================

  function watchLanguageChanges() {

    let lastLocale =
      getLocale();


    const observer =
      new MutationObserver(
        async () => {

          const currentLocale =
            getLocale();


          if (
            currentLocale ===
            lastLocale
          ) {
            return;
          }


          log(
            "Language changed:",
            lastLocale,
            "→",
            currentLocale
          );


          lastLocale =
            currentLocale;


          const container =
            document.getElementById(
              CONFIG.CONTAINER_ID
            );


          if (!container) {
            return;
          }


          const rawHandle =
            getProductHandleFromUrl();


          if (!rawHandle) {
            return;
          }


          const modelKey =
            getModelKeyFromHandle(
              rawHandle
            );


          try {

            const master =
              await loadMaster();


            const found =
              findModel(
                master,
                modelKey
              );


            if (!found) {
              return;
            }


            renderInitialTable(
              container,
              found.data,
              found.key
            );


            setupExplodedMarkersWithRetry(
              container,
              found.data,
              found.key
            );


            await loadShopifyData(
              container,
              found.data
            );


          } catch (err) {

            error(
              "Language change refresh error:",
              err
            );
          }
        }
      );


    observer.observe(
      document.documentElement,
      {
        attributes: true,
        attributeFilter: [
          "lang"
        ]
      }
    );
  }


  // =========================================================
  // INITIALIZE
  // =========================================================

  async function initialize() {

    if (!isProductPage()) {

      log(
        "Not a product page."
      );

      return;
    }


    if (
      window.__explodedViewInitialized
    ) {

      return;
    }


    window.__explodedViewInitialized =
      true;


    /*
     * Pirmiausia paslepiame originalų
     * produkto aprašymo bloką.
     */

    hideOriginalDescription();

    watchOriginalDescription();


    injectStyles();


    const rawHandle =
      getProductHandleFromUrl();


    if (!rawHandle) {

      warn(
        "Could not determine product handle."
      );

      return;
    }


    const modelKey =
      getModelKeyFromHandle(
        rawHandle
      );


    log(
      "Product handle:",
      rawHandle,
      "→ model key:",
      modelKey
    );


    let master;


    try {

      master =
        await loadMaster();

    } catch (err) {

      error(
        "Failed to load master JSON:",
        err
      );


      const container =
        createContainer();


      if (container) {

        container.innerHTML = `
          <div class="ev-error">
            ${t("error")}
          </div>
        `;
      }


      return;
    }


    const found =
      findModel(
        master,
        modelKey
      );


    if (!found) {

      log(
        "No Exploded View for this product."
      );

      return;
    }


    log(
      "Model found:",
      found.key
    );


    const container =
      createContainer();


    if (!container) {
      return;
    }


    renderInitialTable(
      container,
      found.data,
      found.key
    );


    setupExplodedMarkersWithRetry(
      container,
      found.data,
      found.key
    );


    try {

      await loadShopifyData(
        container,
        found.data
      );

    } catch (err) {

      error(
        "Shopify data error:",
        err
      );
    }


    watchLanguageChanges();


    /*
     * Dar kartą patikriname po visko.
     */

    hideOriginalDescription();


    log(
      "Exploded View ready."
    );
  }


  // =========================================================
  // START
  // =========================================================

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initialize,
      {
        once: true
      }
    );

  } else {

    initialize();
  }

})();